import { useEffect, useState } from 'react';
import { checkForUpdate, isDesktopApp, type AvailableUpdate } from '../updater';
import { useStore } from '../store';

/**
 * Aviso de versao nova do app desktop.
 *
 * Fica na barra superior e nao interrompe nada: atualizar e opcional, e o
 * cockpit continua utilizavel na versao antiga. No navegador o componente nao
 * renderiza -- lá a pagina ja vem sempre atualizada do servidor.
 */
export function UpdateBanner() {
  const pushToast = useStore((s) => s.pushToast);
  const [update, setUpdate] = useState<AvailableUpdate | null>(null);
  const [percent, setPercent] = useState<number | null>(null);
  const [installing, setInstalling] = useState(false);

  useEffect(() => {
    if (!isDesktopApp()) return;
    let cancelled = false;

    // Checa na abertura e de hora em hora: quem deixa o app aberto dias
    // seguidos tambem precisa receber correcao.
    const run = () =>
      void checkForUpdate().then((found) => {
        if (!cancelled && found) setUpdate(found);
      });

    run();
    const timer = window.setInterval(run, 3_600_000);
    return () => {
      cancelled = true;
      window.clearInterval(timer);
    };
  }, []);

  if (!update) return null;

  // Recebe o update por parametro em vez de ler o state: dentro da closure o
  // TypeScript nao consegue garantir que ele continua nao-nulo, porque
  // setUpdate pode ter rodado no meio.
  async function install(available: AvailableUpdate) {
    setInstalling(true);
    try {
      await available.install(setPercent);
      // Se chegou aqui sem reiniciar, algo impediu o relaunch.
      pushToast({ kind: 'info', text: 'atualização aplicada; feche e abra o app' });
    } catch (err) {
      pushToast({
        kind: 'error',
        text: `falha ao atualizar: ${err instanceof Error ? err.message : String(err)}`,
      });
      setInstalling(false);
      setPercent(null);
    }
  }

  return (
    <div className="update-banner">
      <span className="dot on" />
      <span className="label" title={update.notes ?? undefined}>
        versão {update.version} disponível
      </span>
      {installing ? (
        <span className="progress">
          {percent === null ? 'baixando…' : `${percent}%`}
        </span>
      ) : (
        <>
          <button className="primary" onClick={() => void install(update)}>
            atualizar
          </button>
          <button className="ghost" onClick={() => setUpdate(null)} title="Lembrar depois">
            ✕
          </button>
        </>
      )}
    </div>
  );
}
